module.exports = __webpack_public_path__ + "225674c764a84982ec54072b9f21ff0d.svg";